// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"e5111d6e","247":"22e3494d","284":"3d4646b5","422":"0feb75a1","440":"71e6200a","627":"fb921618","834":"8d8bc08a","842":"86d55382","867":"f3b5929d","923":"412a0e20","938":"85e5ca22"}[chunkId] + ".chunk.js";
};